export default [
  {
    code: '401',
    message: 'Unauthorized',
    customCodes: [
      {
        code: '0',
        message: 'common.messages.without_permissions',
      },
      {
        code: '1',
        message: 'server.errors.unassigned_person_to_user',
      },
      {
        code: '2',
        message: 'server.errors.inactive_user',
      },
    ],
  },
  {
    code: '403',
    message: 'server.errors.forbidden',
    customCodes: [
      {
        code: '0',
        message: 'server.errors.action_category_has_actions',
      },
      {
        code: '1',
        message: 'server.errors.action_priority_has_actions',
      },
      {
        code: '11',
        message: 'common.errors.not_allowed_role',
      },
      {
        code: '12',
        message: 'server.errors.without_approval_permissions',
      },
      {
        code: '13',
        message: 'server.errors.foreign_department',
      },
      {
        code: '14',
        message: 'server.errors.without_rejection_permissions',
      },
      {
        code: '15',
        message: 'server.errors.already_closed',
      },
      {
        code: '16',
        message: 'common.errors.not_allowed_user',
      },
      {
        code: '17',
        message: 'problem_solving.messages.not_problem_supervisor',
      },
      {
        code: '19',
        message: 'problem_solving.messages.user_is_not_planificator',
      },
    ],
  },
  {
    code: '404',
    message: 'server.errors.not_found',
    customCodes: [
      {
        code: '11',
        message: 'server.errors.gemba_walk_face_to_face_missing_schedule',
      },
    ],
  },
]
